import { useContext } from 'react';
import { StorageScopeContext } from '@contexts/StorageScopeContext';

export function useStorageScope() {
  const context = useContext(StorageScopeContext);
  if (!context) {
    throw new Error('useStorageScope must be used within StorageScopeProvider');
  }
  return context;
}
